module.exports = __webpack_public_path__ + "science.wet-and-dry.car.wet.png?f1c694b0e58c5447251d1eb209663829";